<template lang="pug">
  .form-item
    v-card(flat)
      v-row(align="center" no-gutters)
        v-col.shrink.pl-3.py-3(v-show="showSort")
          v-layout.handle(:class="{ 'drag-active': drag }")
            ArrowsSortIcon.my-auto(size="22" :style="{ 'color': $vuetify.theme.themes[$theme].primary500 }")
        v-col.pa-3
          div
            div.mb-1.s1.basic800--text(style="word-break: break-word") {{ category.name }}
            div.c1.basic600--text {{ $t('products') }}: {{ category.total_products }}
        v-col.shrink.pr-1.py-3(align="end")
          div.d-flex.align-center
            v-menu(left)
              template(v-slot:activator="{ on, attrs }")
                v-btn(icon v-on="on" color="transparent")
                  eva-icon(name="more-vertical-outline" width="20" height="20" :fill="$vuetify.theme.themes[$theme].primary500" style="margin: 3px 1px 0 0")
              v-list(dense)
                v-list-item(@click="clickEdit")
                  v-list-item-title.s2.basic800--text {{ $t('edit') }}
                v-list-item(v-if="category.total_products > 1" @click="showSortProductDialog = true")
                  v-list-item-title.s2.basic800--text {{ $t('sort_products') }}
                v-list-item(@click="clickDelete")
                  v-list-item-title.s2.basic800--text {{ $t('delete_category') }}
            y-switch.mb-n3.ml-n2(v-model="category.enabled" @change="onChangeStatus(category.enabled)")
        
    v-divider.basic300
        
    .modals
      add-menu-category(v-if="showAddCategoryDialog" :open.sync="showAddCategoryDialog" :company="company" :category.sync="category")
      sort-category-product(v-if="showSortProductDialog" :open.sync="showSortProductDialog" :category.sync="category" :company="company")
      y-dialog(v-if="openDeleteDialog" v-model='openDeleteDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_category') }}
          v-card-text.p2.primary500--text.px-4 {{ $t('delete_category_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete')
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import { mapActions } from 'vuex'
import AddMenuCategory from '@/components/restaurant/dialogs/AddMenuCategory.vue'
import SortCategoryProduct from '@/components/dialogs/SortCategoryProduct.vue'

export default {
  name: 'CategoryItem',
  props: ['category', 'company', 'drag', 'showSort'],
  components: { AddMenuCategory, SortCategoryProduct },
  data: () => ({
    openDeleteDialog: false,
    showAddCategoryDialog: false,
    showSortProductDialog: false,
  }),
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickEdit () {
      this.showAddCategoryDialog = true
    },
    clickDelete () {
      this.openDeleteDialog = true
    },
    startDelete() {
      this.axios.delete(`/product_categories/${this.category.id}/`)
        .then(() => {
          this.$emit('deleted', this.category)
          this.openDeleteDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    onChangeStatus (val) {
      this.axios.patch(`/product_categories/${this.category.id}/`, { enabled: val })
        .then(() => {
          if (val) {
            this.showMessage(['success', this.$t('success_message.category_published_successfully')])
          } else {
            this.showMessage(['success', this.$t('success_message.category_changed_draft')])
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style scoped>
.drag-active { cursor: grabbing; }
</style>

<i18n>
{
  "en": {
    "delete_category_confirmation": "Are you sure you want to delete this category? This category will be deleted permanently."
  },
  "id": {
    "delete_category_confirmation": "Anda yakin ingin menghapus kategori ini? Kategori ini akan dihapus secara permanen."
  }
}
</i18n>